import { Routes, Route } from 'react-router-dom'
import AdminOverview from './AdminOverview'
import Tenants from './Tenants'
import Content from './Content'
import Analytics from './Analytics'
import System from './System'
import Settings from './Settings'
import { TenantManagement } from '../../components/admin/TenantManagement'
import { TenantHealthDashboard } from '../../components/admin/TenantHealthDashboard'
import MediaRecordPage from '../MediaRecordPage'

const AdminDashboard: React.FC = () => {
  return (
    <Routes>
      <Route index element={<AdminOverview />} />
      <Route path="tenants" element={<Tenants />} />
      <Route path="tenant-management" element={<TenantManagement />} />
      <Route path="tenant-health" element={<TenantHealthDashboard />} />
      <Route path="content" element={<Content />} />
      <Route path="analytics" element={<Analytics />} />
      <Route path="system" element={<System />} />
      <Route path="settings" element={<Settings />} />
      <Route path="media/:mediaId" element={<MediaRecordPage />} />
    </Routes>
  )
}

export default AdminDashboard 